import Image from "next/image";
import Link from "next/link";
import useSWR from "swr";

export function Tenant(props) {
  function moveDetail(data) {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("tenant", JSON.stringify(data));
    }
  }

  return (
    <div className="grid w-full my-4 sm:my-16">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 px-4 sm:px-8 md:px-10 lg:px-20">
        {props.dataTenants.length > 0 ? (
          props.dataTenants.map((data, key) => (
            <div key={key} className="relative z-10 grid">
              <Link
                href={{ pathname: "/directions/[did]", query: data }}
                as={`/directions/${data.tenant_name
                  .split(" ")
                  .join("-")
                  .toLowerCase()}`}
              >
                <img
                  onClick={() => moveDetail(data)}
                  src={data.tenant_image}
                  alt={data.tenant_name}
                  className="block sm:hidden w-full"
                />
              </Link>
              <img
                src={data.tenant_image}
                alt={data.tenant_name}
                className="hidden sm:block w-full"
              />
              <div className="hidden sm:block absolute top-0 left-0 bottom-0 right-0 purple-mix opacity-0 hover:opacity-90">
                <div className="grid h-full text-center self-center">
                  <p className="text-sm sm:text-base md:leading-3 lg:leading-4 xl:leading-normal 2xl:leading-none text-white sora font-semibold self-center pt-0 xl:pt-5">
                    {data.tenant_name}
                    <br />
                    <span className="text-sm text-white sora font-light self-center">
                      {data.tenan_category_name} - {data.floor_name}
                    </span>
                    <br />
                    <span className="text-xs text-white px-1 sora font-light self-center line-clamp">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.tenant_description,
                        }}
                      ></div>
                    </span>
                  </p>
                  <Link
                    href={{ pathname: "/directions/[did]", query: data }}
                    as={`/directions/${data.tenant_name
                      .split(" ")
                      .join("-")
                      .toLowerCase()}`}
                  >
                    <button
                      onClick={() => moveDetail(data)}
                      type="button"
                      className="w-9/12 lg:w-4/5 m-auto mt-0 text-xs sm:text-xs md:text-xs lg:text-base text-center text-white sora font-extralight border py-2 px-4"
                    >
                      See more &nbsp;&nbsp;&rarr;
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="relative z-10 grid">
            <p>Hasil tidak ditemukan</p>
          </div>
        )}
      </div>
    </div>
  );
}
